<template>
  <a-result status="404" title="404" sub-title="找不到此页面">
    <template #extra>
      <a-button type="primary" @click="toHome">
        返回首页
      </a-button>
    </template>
  </a-result>
</template>

<script setup lang="ts">

import {useRouter} from "vue-router";
import {notification} from "ant-design-vue";

const router = useRouter()
const toHome = () => {
  router.push({path: '/'}).catch(err => notification.error({message: err}))
}
</script>

<style scoped lang="sass">

</style>